import React from 'react';
import PropTypes from 'prop-types';
import { Radio, Divider, Segment } from 'semantic-ui-react';
import _ from 'lodash';
import hasRESTClient from '../../hocs/has-rest-client';

const radioLabelStyle = {
  'vertical-align': 'super',
};

const titleStyle = {
  paddingBottom: 5,
  display: 'block',
};

class CampaignScanningSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount = async () => {
    const { restClient, campaignId } = this.props;
    const response = await restClient.get(`campaigns/${campaignId}`);
    const campaign = _.get(response, 'data.data.attributes', {});
    this.setState({
      campaign,
    });
  }

  toggleCheckbox = async (event, { name, checked }) => {
    const { restClient, campaignId } = this.props;

    const payload = {
      data: {
        attributes: {
          [name]: checked,
        },
      },
    };

    const campaignResponse = await restClient.patch(`campaigns/${campaignId}`, payload);
    const campaign = campaignResponse.data.data;
    this.setState({
      campaign: campaign.attributes,
    });
  }

  render() {
    //
    const {
      campaign,
    } = this.state;


    const scanInstagram = campaign && campaign.scanInstagram;
    const scanTiktok = campaign && campaign.scanTiktok;
    const scanTelegram = campaign && campaign.scanTelegram;
    const scanFacebook = campaign && campaign.scanFacebook;
    const scanTwitter = campaign && campaign.scanTwitter;
    const scanYoutube = campaign && campaign.scanYoutube;

    return (
      <Segment>
        <h3 style={titleStyle}>Campaign Scanning Options</h3>
        <p>Choose which social platforms you want to scan.</p>

        { campaign &&
          <div style={{ padding: 30 }}>

            <div>
              <table width="100%">

                <tr>
                  <td>
                    <Radio
                      toggle
                      name="scanInstagram"
                      checked={scanInstagram !== false}
                      onChange={this.toggleCheckbox}
                    /> <span style={radioLabelStyle} >&nbsp;Instagram</span>

                  </td>
                  <td>
                    <Radio
                      toggle
                      name="scanTiktok"
                      checked={scanTiktok !== false}
                      onChange={this.toggleCheckbox}
                    /> <span style={radioLabelStyle} >&nbsp;TikTok</span>
                  </td>
                  <td>
                    <Radio
                      toggle checked={scanFacebook}
                      name="scanFacebook"
                      onChange={this.toggleCheckbox}
                    /> <span style={radioLabelStyle} >&nbsp;Facebook</span>
                  </td>
                </tr>
                <tr>
                  <div>&nbsp;</div>
                </tr>
                <tr>
                  <td >
                    <Radio
                      toggle checked={scanYoutube}
                      name="scanYoutube"
                      onChange={this.toggleCheckbox}
                    /> <span style={radioLabelStyle} >&nbsp;YouTube</span>

                  </td>
                  <td >
                    <Radio
                      toggle checked={scanTwitter}
                      name="scanTwitter"
                      onChange={this.toggleCheckbox}
                    /> <span style={radioLabelStyle} >&nbsp;Twitter</span>

                  </td>
                  <td >
                    <Radio
                      toggle checked={scanTelegram !== false}
                      name="scanTelegram"
                      onChange={this.toggleCheckbox}
                    /> <span style={radioLabelStyle} >&nbsp;Telegram</span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        }
      </Segment>
    );
  }
}

CampaignScanningSettings.propTypes = {
  restClient: PropTypes.object.isRequired,
};

export default hasRESTClient(CampaignScanningSettings);



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-scanning-settings/index.js
 **/